import { defineSlotRecipe } from '@chakra-ui/react';

export const tableSlotRecipe = defineSlotRecipe({
  className: 'chakra-table',
  slots: ['root', 'caption', 'header', 'body', 'footer', 'row', 'columnHeader', 'cell'],
  base: {
    root: {
      width: '100%',
      height: 'auto',
    },
    header: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
    },
  },
});
